import $ from "jquery";
import Sortable from "sortablejs";
import fetch from "mojave/polyfill/fetch";


export class SortableHandler
{
	/**
	 * @private
	 * @type {HTMLElement}
	 */
	container;

	/**
	 * @param {HTMLElement} container
	 */
	constructor (container)
	{
		this.container = container;
	}


	/**
	 *
	 */
	init ()
	{
		if (this.container.childElementCount <= 1)
		{
			return;
		}

		new Sortable(this.container, {
			handle: ".sortable-handle",
			onSort: () => this.onSortUpdate(),
		});
	}


	/**
	 * Callback on when the sorting has changed
	 */
	onSortUpdate ()
	{
		const url = $(this.container).data("sortable");
		const mapping = {};

		$(this.container).children()
			.each(
				(index, element) =>
				{
					const id = $(element).data("id");
					mapping[id] = index;
				}
			);

		fetch(url, {
			method: "post",
			body: JSON.stringify(mapping),
			credentials: "include",
			cache: "no-cache",
		})
			.then(response => response.json())
			.then(
				data =>
				{
					if ("ok" !== data.status)
					{
						this.onRequestFailure();
					}
				},
				() => this.onRequestFailure()
			);
	}


	/**
	 * @private
	 */
	onRequestFailure ()
	{
		alert("Die Anfrage ist leider fehlgeschlagen. Die Seite wird neugeladen – bitte versuchen Sie es erneut.");
		document.location.reload(true);
	}
}
